import { ColorDLS } from '../../styling/color';

const AllLineColors: ColorDLS[][] = [
  [ColorDLS.Blue40],
  [ColorDLS.Blue40, ColorDLS.Blue20],
  [ColorDLS.Blue45, ColorDLS.Blue30, ColorDLS.Blue15],
  [ColorDLS.Blue60, ColorDLS.Blue40, ColorDLS.Blue25, ColorDLS.Blue15],
  [ColorDLS.Blue70, ColorDLS.Blue50, ColorDLS.Blue35, ColorDLS.Blue20, ColorDLS.Blue10],
  [
    ColorDLS.Blue80,
    ColorDLS.Blue55,
    ColorDLS.Blue40,
    ColorDLS.Blue30,
    ColorDLS.Blue20,
    ColorDLS.Blue10,
  ],
  [
    ColorDLS.Blue80,
    ColorDLS.Blue55,
    ColorDLS.Blue40,
    ColorDLS.Blue30,
    ColorDLS.Blue20,
    ColorDLS.Blue10,
    ColorDLS.Blue05,
  ],
];

export const getDLSLineColors = (nrOfSeries: number) =>
  nrOfSeries > 0 && nrOfSeries <= 7
    ? AllLineColors[nrOfSeries - 1]
    : ([] as ColorDLS[]).fill(ColorDLS.Blue40, 0, nrOfSeries);
